import { render } from "./document-notes.vue?vue&type=template&id=3e7a7df2&scoped=true"
import script from "./document-notes.vue?vue&type=script&lang=js"
export * from "./document-notes.vue?vue&type=script&lang=js"

import "./document-notes.vue?vue&type=style&index=0&id=3e7a7df2&scoped=true&lang=css"
import "./document-notes.vue?vue&type=style&index=1&id=3e7a7df2&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e7a7df2"]])

export default __exports__